"use strict";

require("core-js/modules/es6.array.filter.js");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TourType = exports.TimeslotType = exports.TariffType = exports.ProductRowType = exports.PerformanceType = exports.HospitalitySessionType = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _secutixObjects = require("@gravity/secutix-objects");
var _constants = require("./constants");
function cov_2pzlb90sb3() {
  var path = "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/product/lib/type.js";
  var hash = "04ec235d3bae368bc0f971dcc829ad5b015aa2c3";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src609432752/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/product/lib/type.js",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 22
        },
        end: {
          line: 22,
          column: 2
        }
      },
      "1": {
        start: {
          line: 24,
          column: 26
        },
        end: {
          line: 43,
          column: 2
        }
      },
      "2": {
        start: {
          line: 45,
          column: 17
        },
        end: {
          line: 56,
          column: 2
        }
      },
      "3": {
        start: {
          line: 62,
          column: 23
        },
        end: {
          line: 66,
          column: 2
        }
      },
      "4": {
        start: {
          line: 74,
          column: 28
        },
        end: {
          line: 93,
          column: 2
        }
      },
      "5": {
        start: {
          line: 99,
          column: 31
        },
        end: {
          line: 139,
          column: 2
        }
      },
      "6": {
        start: {
          line: 145,
          column: 38
        },
        end: {
          line: 170,
          column: 2
        }
      },
      "7": {
        start: {
          line: 175,
          column: 30
        },
        end: {
          line: 186,
          column: 2
        }
      },
      "8": {
        start: {
          line: 194,
          column: 20
        },
        end: {
          line: 255,
          column: 2
        }
      },
      "9": {
        start: {
          line: 260,
          column: 24
        },
        end: {
          line: 262,
          column: 2
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "04ec235d3bae368bc0f971dcc829ad5b015aa2c3"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2pzlb90sb3 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_2pzlb90sb3();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var AdvantageType = (cov_2pzlb90sb3().s[0]++, _propTypes.default.shape({
  type: _propTypes.default.oneOf(['PUBLIC', 'CODE', 'CONTACT']),
  id: _propTypes.default.number,
  // WARNING: the name is initialy a map of locale -> translation. It is kept in the attribute rawName
  name: _propTypes.default.string,
  rawName: _propTypes.default.objectOf(_propTypes.default.string),
  // WARNING: the description is initialy a map of locale -> translation. It is kept in the attribute rawDescription
  description: _propTypes.default.string,
  rawDescription: _propTypes.default.objectOf(_propTypes.default.string),
  image: _propTypes.default.string,
  availability: _propTypes.default.oneOf(['NONE', 'LIMITED', 'GOOD']),
  firstDate: _propTypes.default.string,
  lastDate: _propTypes.default.string,
  isLimited: _propTypes.default.bool,
  isUsed: _propTypes.default.bool
}));
var TariffType = exports.TariffType = (cov_2pzlb90sb3().s[1]++, _propTypes.default.shape({
  // General information
  seatCategoryId: _propTypes.default.number,
  seatCategoryName: _propTypes.default.string,
  seatCategoryRank: _propTypes.default.number,
  bgColor: _propTypes.default.string,
  textColor: _propTypes.default.string,
  maxQuantity: _propTypes.default.number,
  minQuantity: _propTypes.default.number,
  availability: _propTypes.default.oneOf(['NONE', 'LIMITED', 'GOOD']),
  // Rate information
  rateName: _propTypes.default.string,
  rateId: _propTypes.default.number,
  rateRank: _propTypes.default.number,
  // the amount
  price: _secutixObjects.PriceType
}));
var TeamType = (cov_2pzlb90sb3().s[2]++, _propTypes.default.shape({
  // WARNING: the name is initialy a map of locale -> translation. It is kept in the attribute rawName
  name: _propTypes.default.string,
  rawName: _propTypes.default.objectOf(_propTypes.default.string),
  logo: _propTypes.default.shape({
    small: _propTypes.default.string,
    medium: _propTypes.default.string,
    large: _propTypes.default.string,
    xlarge: _propTypes.default.string
  }),
  code: _propTypes.default.string
}));

/**
 * Data to represent a theme of a visit
 * TODO : simple name and translation should not have a specific proptypes
 */
var VisitThemeType = (cov_2pzlb90sb3().s[3]++, _propTypes.default.shape({
  // WARNING: the name is initialy a map of locale -> translation. It is kept in the attribute rawName
  name: _propTypes.default.string,
  rawName: _propTypes.default.objectOf(_propTypes.default.string)
}));
/**
 * TODO : merge timeslot type and performance type into Occurrence
 */
/**
 * Timeslot representation
 * All extra information must be inside the product that contains it
 */
var TimeslotType = exports.TimeslotType = (cov_2pzlb90sb3().s[4]++, _propTypes.default.shape({
  id: _propTypes.default.number,
  start: _propTypes.default.string,
  end: _propTypes.default.string,
  availability: _propTypes.default.oneOf(['NONE', 'LIMITED', 'GOOD']),
  visitLanguages: _propTypes.default.arrayOf(_propTypes.default.string),
  visitThemes: _propTypes.default.arrayOf(VisitThemeType),
  withAdvantage: _propTypes.default.bool,
  action: _propTypes.default.shape({
    buy: _propTypes.default.string,
    book: _propTypes.default.string,
    option: _propTypes.default.string,
    request: _propTypes.default.request
  }),
  notOnSales: _propTypes.default.bool,
  restrictedAdv: _propTypes.default.bool,
  salesStartDate: _propTypes.default.string,
  minAmount: _propTypes.default.number
}));

/**
 * Performance representation
 * All extra information can be gotten from the product that contains it
 */
var PerformanceType = exports.PerformanceType = (cov_2pzlb90sb3().s[5]++, _propTypes.default.shape({
  // General
  id: _propTypes.default.number,
  // WARNING: the name is initialy a map of locale -> translation. It is kept in the attribute rawName
  name: _propTypes.default.string,
  rawName: _propTypes.default.objectOf(_propTypes.default.string),
  // WARNING: the description is initialy a map of locale -> translation. It is kept in the attribute rawSubtitle
  subtitle: _propTypes.default.string,
  rawSubtitle: _propTypes.default.objectOf(_propTypes.default.string),
  date: _propTypes.default.string,
  venue: _propTypes.default.string,
  action: _propTypes.default.shape({
    buy: _propTypes.default.string,
    book: _propTypes.default.string,
    option: _propTypes.default.string,
    request: _propTypes.default.request
  }),
  availability: _propTypes.default.oneOf(['NONE', 'LIMITED', 'GOOD']),
  image: _propTypes.default.shape({
    small: _propTypes.default.string,
    medium: _propTypes.default.string,
    large: _propTypes.default.string,
    xlarge: _propTypes.default.string
  }),
  prices: _propTypes.default.arrayOf(_secutixObjects.PriceType),
  // For championship matches only
  isFinalDate: _propTypes.default.bool,
  roundName: _propTypes.default.string,
  roundCode: _propTypes.default.string,
  matchRound: _propTypes.default.string,
  hostTeam: TeamType,
  opposingTeam: TeamType,
  withAdvantage: _propTypes.default.bool,
  notOnSales: _propTypes.default.bool,
  restrictedAdv: _propTypes.default.bool,
  salesStartDate: _propTypes.default.string,
  minAmount: _propTypes.default.number,
  description: _propTypes.default.string,
  rawDescription: _propTypes.default.objectOf(_propTypes.default.string)
}));

/**
 * Hospitality representation
 * All extra information can be gotten from the product that contains it
 */
var HospitalitySessionType = exports.HospitalitySessionType = (cov_2pzlb90sb3().s[6]++, _propTypes.default.shape({
  // General
  id: _propTypes.default.number,
  // WARNING: the name is initialy a map of locale -> translation. It is kept in the attribute rawName
  name: _propTypes.default.string,
  rawName: _propTypes.default.objectOf(_propTypes.default.string),
  // WARNING: the description is initialy a map of locale -> translation. It is kept in the attribute rawSubtitle
  date: _propTypes.default.string,
  time: _propTypes.default.string,
  action: _propTypes.default.shape({
    buy: _propTypes.default.string,
    book: _propTypes.default.string,
    option: _propTypes.default.string,
    request: _propTypes.default.request
  }),
  availability: _propTypes.default.oneOf(['NONE', 'LIMITED', 'GOOD']),
  prices: _propTypes.default.arrayOf(_secutixObjects.PriceType),
  // For championship matches only
  isFinalDate: _propTypes.default.bool,
  roundName: _propTypes.default.string,
  roundCode: _propTypes.default.string,
  matchRound: _propTypes.default.string,
  hostTeam: TeamType,
  opposingTeam: TeamType
}));
/**
 * TODO : remove from the product nucleo when tournament code is removed,
 * specific to the UI
 */
var ProductRowType = exports.ProductRowType = (cov_2pzlb90sb3().s[7]++, _propTypes.default.shape({
  // Indicates if the column will be shown on the header
  showHeader: _propTypes.default.bool,
  // Indicates if the content is centered
  centered: _propTypes.default.bool,
  // Indicates if the order of the column
  rank: _propTypes.default.number,
  // Indicates if the width
  weight: _propTypes.default.number,
  // Action to be made when click over the column
  handleAction: _propTypes.default.func
}));

/**
 * Data representing any type of product
 * Some properties are not used for certain type of products
 *      -> for a performance, the timeslots property is undefined
 *      -> for a adhesion lastDate will not exist
 */
var ProductType = (cov_2pzlb90sb3().s[8]++, _propTypes.default.shape({
  id: _propTypes.default.number,
  code: _propTypes.default.string,
  // WARNING: the name is initialy a map of locale -> translation. It is kept in the attribute rawName
  name: _propTypes.default.string,
  rawName: _propTypes.default.objectOf(_propTypes.default.string),
  // WARNING: the description is initialy a map of locale -> translation. It is kept in the attribute rawDescription
  description: _propTypes.default.string,
  rawDescription: _propTypes.default.objectOf(_propTypes.default.string),
  action: _propTypes.default.shape({
    buy: _propTypes.default.string,
    book: _propTypes.default.string,
    option: _propTypes.default.string,
    request: _propTypes.default.request
  }),
  productType: _propTypes.default.oneOf((0, _values.default)(_constants.ProductTypeEnum)),
  productFamily: _propTypes.default.oneOf(['EVENT', 'SEASON_TICKET', 'PASS', 'OTHER', 'HOSPITALITY', 'HOSPITALITY_BUNDLE']),
  productFamilyName: _propTypes.default.objectOf(_propTypes.default.string),
  image: _propTypes.default.shape({
    small: _propTypes.default.string,
    medium: _propTypes.default.string,
    large: _propTypes.default.string,
    xlarge: _propTypes.default.string
  }),
  availability: _propTypes.default.oneOf(['NONE', 'LIMITED', 'GOOD']),
  // WARNING: the description is initialy a map of locale -> translation. It is kept in the attribute rawSubtitle
  subtitle: _propTypes.default.string,
  rawSubtitle: _propTypes.default.objectOf(_propTypes.default.string),
  location: _propTypes.default.string,
  firstDate: _propTypes.default.string,
  lastDate: _propTypes.default.string,
  advantages: _propTypes.default.arrayOf(AdvantageType),
  // Performances and timeslots are array of occurrences in the product
  // if there is only one occurrence, it may be considered as the occurrence (i.e. timeslot or performance itself)
  performances: _propTypes.default.arrayOf(PerformanceType),
  timeslots: _propTypes.default.arrayOf(TimeslotType),
  notOnSales: _propTypes.default.bool,
  restrictedAdv: _propTypes.default.bool,
  salesStartDate: _propTypes.default.string,
  nextSeasonLinkedProductId: _propTypes.default.number,
  previousSeasonLinkedProductId: _propTypes.default.number,
  // TODO : remove, replaced by minPrice
  minAmount: _propTypes.default.number,
  /**
   * The minimum price of a product, used to show a marketing work like
   * From 3,00 eur
   */
  minPrice: _secutixObjects.PriceType,
  /**
   * the list of tariff linked to each audienceSubCategoryId
   */
  tariffs: _propTypes.default.arrayOf(TariffType),
  subTopicsList: _propTypes.default.arrayOf(_propTypes.default.string)
}));

/**
 * Data type represent for Tour
 */
var TourType = exports.TourType = (cov_2pzlb90sb3().s[9]++, _propTypes.default.shape(_objectSpread({}, ProductType)));
var _default = exports.default = ProductType;